// extracted by mini-css-extract-plugin
module.exports = {"heroImg":"heroSection_heroImg__3ygHS","headingBox":"heroSection_headingBox__3vcH4","btn":"heroSection_btn__10ZUw","buttonPrimary":"heroSection_buttonPrimary__LdMN3"};